export const BaseLink = 'https://admin.ingeniouslearn.com/api/v1';
// export const BaseLink = 'https://admin.ingeniouslearn.com/api/v1/api/v1';
